type IconOptions = { rounded?: boolean; bg?: string; gold?: string; accent?: string };

/** The Corventa symbol: an open diamond "C", a central talent node, and a line connecting it to opportunity. */
export function brandIconSvg({ rounded = true, bg = '#0A1426', gold = '#C9A96E', accent = '#93ABD6' }: IconOptions = {}): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="${rounded ? 14 : 0}" fill="${bg}"/><g transform="translate(8 8)"><path d="M34 14 L24 4 L4 24 L24 44 L34 34" fill="none" stroke="${gold}" stroke-width="5.5" stroke-linejoin="miter" stroke-linecap="square"/><path d="M28 24 H41" stroke="${accent}" stroke-width="3.5" stroke-linecap="round"/><rect x="19.5" y="19.5" width="9" height="9" transform="rotate(45 24 24)" fill="${gold}"/><circle cx="43" cy="24" r="3.6" fill="${accent}"/></g></svg>`;
}

export function svgDataUri(svg: string): string {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export function rasterizeSvg(svg: string, size: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Canvas unavailable'));
      ctx.drawImage(img, 0, 0, size, size);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Icon render failed'));
    img.src = svgDataUri(svg);
  });
}
